import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { DeviceUISettingsProvider } from '../device-ui-settings';
import { DeviceConfig } from '../device/config/types';
import { DeviceState } from '../device/state/types';
import { DeviceIconState } from 'console/device/icon/types';
import { HeatingDeviceEntitiesConfig } from './types';
import { useZ3KBoilerHeatingCircuitsConfig, useZ3KCustomControlsConfig, useZ3KEntitiesConfig, useZ3KHeatingCircuitsConfig, useZ3KHeatingModesConfig, useZ3KSensorsConfig, useZ3KThermometersConfig, } from './lib/hooks/entities/z3k';
export const Z3KHeatingDeviceConfigProvider = memo(function Z3KHeatingDeviceContentProvider(props) {
    const { children, custom_config_ids, templates, support_ui_settings } = props;
    const { is_climatic, z3k_config, device_id } = useContext(DeviceConfig);
    const { is_service_mode, icon_state } = useContext(DeviceState);
    const show_hidden_elements = useMemo(() => (is_service_mode || custom_config_ids ? true : false), [is_service_mode, custom_config_ids]);
    const show_alarm_heating_circuits = useMemo(() => show_hidden_elements || icon_state === DeviceIconState.alarm, [show_hidden_elements, icon_state]);
    const heating_circuits = useZ3KHeatingCircuitsConfig(device_id, z3k_config, is_climatic, show_alarm_heating_circuits);
    const { heating_modes, boiler_heating_modes } = useZ3KHeatingModesConfig(device_id, z3k_config, is_climatic, show_hidden_elements);
    const boiler_heating_circuits = useZ3KBoilerHeatingCircuitsConfig(z3k_config, is_climatic, show_alarm_heating_circuits);
    const custom_controls = useZ3KCustomControlsConfig(device_id, z3k_config, show_hidden_elements);
    const thermometers = useZ3KThermometersConfig(z3k_config, is_climatic);
    const sensors = useZ3KSensorsConfig(z3k_config, is_climatic);
    const entities_config = useZ3KEntitiesConfig({
        heating_circuits,
        heating_modes,
        boiler_heating_circuits,
        boiler_heating_modes,
        thermometers,
        sensors,
        custom_controls,
    }, custom_config_ids);
    const provider = useMemo(() => {
        if (support_ui_settings) {
            return (_jsx(DeviceUISettingsProvider, { device_config: entities_config, templates: templates, children: children }));
        }
        return children;
    }, [support_ui_settings, children]);
    return (_jsx(HeatingDeviceEntitiesConfig.Provider, { value: entities_config, children: provider }));
});
